import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import api, { apiErr } from "@/lib/api";
import { toast } from "@/components/ui/sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const UNITS = ["kg", "gr", "lt", "ml", "τεμ", "δεσμ", "φακ"];
const blank = { name: "", category: "", unit: "kg", price_per_unit: 0, price_target: 0, supplier: "", waste_pct: 0, notes: "", count_in_stock: true, needs_offer: true };

export const ItemDialog = ({ item, cats, onClose, onSaved }) => {
  const [f, setF] = useState(blank);
  useEffect(() => {
    if (item) {
      setF({ ...blank, ...Object.fromEntries(Object.keys(blank).map((k) => [k, item[k] ?? blank[k]])) });
    }
  }, [item]);
  const save = useMutation({
    mutationFn: async () => {
      const body = { ...f, price_per_unit: Number(f.price_per_unit) || 0, price_target: Number(f.price_target) || 0, waste_pct: Number(f.waste_pct) || 0 };
      return item?.id ? (await api.put(`/recipes/ingredients/${item.id}`, body)).data : (await api.post("/recipes/ingredients", body)).data;
    },
    onSuccess: () => { toast.success(item?.id ? "Το είδος ενημερώθηκε" : "Το είδος προστέθηκε"); onSaved(); },
    onError: (e) => toast.error(apiErr(e)),
  });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const inp = "mt-1 w-full rounded-lg border border-[#E3DED4] px-3 py-2 text-sm";
  const lbl = "text-xs font-semibold text-[#6F6A60]";
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="catalog-dialog">
        <DialogHeader>
          <DialogTitle>{item?.id ? "Επεξεργασία είδους" : "Νέο είδος"}</DialogTitle>
          <DialogDescription>Τα στοιχεία ισχύουν και για τις συνταγές και τις προμήθειες.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <label className={`${lbl} col-span-2`}>Όνομα<input data-testid="catalog-f-name" className={inp} value={f.name} onChange={set("name")} /></label>
          <label className={lbl}>Κατηγορία<input data-testid="catalog-f-category" list="catalog-cats" className={inp} value={f.category} onChange={set("category")} /></label>
          <datalist id="catalog-cats">{cats.map((c) => <option key={c} value={c} />)}</datalist>
          <label className={lbl}>Μονάδα<select data-testid="catalog-f-unit" className={inp} value={f.unit} onChange={set("unit")}>{UNITS.map((u) => <option key={u}>{u}</option>)}</select></label>
          <label className={lbl}>Τιμή €<input data-testid="catalog-f-price" type="number" step="0.01" className={inp} value={f.price_per_unit} onChange={set("price_per_unit")} /></label>
          <label className={lbl}>Τιμή-στόχος €<input data-testid="catalog-f-target" type="number" step="0.01" className={inp} value={f.price_target} onChange={set("price_target")} /></label>
          <label className={`${lbl} col-span-2`}>Τρέχων προμηθευτής (κείμενο)<input data-testid="catalog-f-supplier" className={inp} value={f.supplier} onChange={set("supplier")} /></label>
          <label className={`${lbl} col-span-2`}>Σημειώσεις<input data-testid="catalog-f-notes" className={inp} value={f.notes} onChange={set("notes")} /></label>
          <label className="flex items-center gap-2 text-sm text-[#45423C]"><input data-testid="catalog-f-needs" type="checkbox" checked={f.needs_offer} onChange={set("needs_offer")} /> Θέλω προσφορά</label>
          <label className="flex items-center gap-2 text-sm text-[#45423C]"><input data-testid="catalog-f-stock" type="checkbox" checked={f.count_in_stock} onChange={set("count_in_stock")} /> Μετράει στην απογραφή</label>
        </div>
        <div className="flex justify-end gap-2 mt-2">
          <button data-testid="catalog-cancel" onClick={onClose} className="rounded-xl border border-[#E3DED4] px-4 py-2 text-sm font-semibold text-[#6F6A60]">Άκυρο</button>
          <button data-testid="catalog-save" onClick={() => save.mutate()} disabled={save.isPending || !f.name.trim()} className="rounded-xl bg-[#45423C] px-4 py-2 text-sm font-semibold text-white disabled:opacity-50">Αποθήκευση</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
